import { Injectable } from '@angular/core';
import { Deposit } from '../../../types/Deposit';
import { CoreService } from '../../core.service';
import { IDepositsService } from '../IDepositsService';
import { mockDeposits } from './mock-data';

@Injectable({
  providedIn: 'root',
})
export class MockDepositsService implements IDepositsService {
  constructor(private _coreService: CoreService) {}

  async getDeposits(): Promise<Deposit[]> {
    console.log('Fetching mock deposits data');
    return this._coreService.delayResolve(mockDeposits);
  }

  async allocateDeposit(depositId: string, clientId: string): Promise<boolean> {
    console.log('Allocating mock deposit', depositId, 'to client', clientId);

    // Find the deposit in mock data
    const depositIndex = mockDeposits.findIndex((d) => d.id === depositId);
    if (depositIndex !== -1) {
      // Update the deposit status and partner
      mockDeposits[depositIndex] = {
        ...mockDeposits[depositIndex],
        partnerId: clientId,
        status: 'Classified',
      };
      return this._coreService.delayResolve(true);
    }

    throw new Error('Deposit not found');
  }
}
